import { render, staticRenderFns } from "./xbcm.vue?vue&type=template&id=e43e3284&scoped=true"
import script from "./xbcm.vue?vue&type=script&lang=js"
export * from "./xbcm.vue?vue&type=script&lang=js"
import style0 from "./xbcm.vue?vue&type=style&index=0&id=e43e3284&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43e3284",
  null
  
)

export default component.exports